function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2020(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3.75,
    height: 5.53,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 2.765
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.53,
    width: 3.75,
    height: 14.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 12.74
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.95,
    width: 3.75,
    height: 32.43,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 36.165
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.39,
    width: 3.75,
    height: 46.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.5357142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 75.76
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 99.13,
    width: 3.75,
    height: 50.32,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 124.28999999999999
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 149.45,
    width: 3.75,
    height: 59.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 179.17499999999998
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 208.9,
    width: 3.75,
    height: 70.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 244.315
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 279.73,
    width: 3.75,
    height: 76.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.46875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 318.115
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.5,
    width: 3.75,
    height: 84.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 398.545
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 440.59,
    width: 3.75,
    height: 84.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 482.775
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 524.95,
    width: 3.75,
    height: 85.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.4166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 567.715
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 610.48,
    width: 3.75,
    height: 89.52,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.875,
    y: 655.24
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 0,
    width: 18.29,
    height: 34.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.895,
    y: 17.07
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.04,
    y: 0,
    width: 19.25,
    height: 34.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.40625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.665,
    y: 17.07
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.29,
    y: 0,
    width: 22.28,
    height: 34.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4755555555555557
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.43,
    y: 17.07
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.56,
    y: 0,
    width: 23.56,
    height: 34.14,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9266666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.34,
    y: 17.07
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.12,
    y: 0,
    width: 23.63,
    height: 34.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.935,
    y: 17.07
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.75,
    y: 0,
    width: 23.64,
    height: 34.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.57,
    y: 17.07
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 0,
    width: 24.43,
    height: 34.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.605,
    y: 17.07
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.82,
    y: 0,
    width: 24.94,
    height: 34.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.29,
    y: 17.07
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.76,
    y: 0,
    width: 34.97,
    height: 34.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.245,
    y: 17.07
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.73,
    y: 0,
    width: 35.54,
    height: 34.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.5,
    y: 17.07
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.27,
    y: 0,
    width: 35.97,
    height: 34.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.828
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.255,
    y: 17.07
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.23,
    y: 0,
    width: 44.06,
    height: 34.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 312.26,
    y: 17.07
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.29,
    y: 0,
    width: 46.53,
    height: 34.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.555,
    y: 17.07
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.83,
    y: 0,
    width: 53.1,
    height: 34.14,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.38,
    y: 17.07
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.92,
    y: 0,
    width: 56.45,
    height: 34.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.14500000000004,
    y: 17.07
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.37,
    y: 0,
    width: 59.16,
    height: 34.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.95,
    y: 17.07
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.54,
    y: 0,
    width: 74.26,
    height: 34.14,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 586.67,
    y: 17.07
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.8,
    y: 0,
    width: 76.2,
    height: 34.14,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.9,
    y: 17.07
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 34.14,
    width: 62.78,
    height: 43.39,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.8475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 55.835
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 77.54,
    width: 62.78,
    height: 45.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.104000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 100.30000000000001
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 123.06,
    width: 62.78,
    height: 51.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.756666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 148.965
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 174.87,
    width: 62.78,
    height: 64.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2780000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 207.17000000000002
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 239.47,
    width: 62.78,
    height: 65.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.463333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 272.225
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 304.98,
    width: 62.78,
    height: 69.5,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.556000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 339.73
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 374.48,
    width: 62.78,
    height: 71.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.185333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 410.095
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 445.71,
    width: 62.78,
    height: 73.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 482.265
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 518.82,
    width: 62.78,
    height: 89.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.82923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 563.495
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 608.18,
    width: 62.78,
    height: 91.82,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.463333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.14,
    y: 654.0899999999999
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.53,
    y: 34.14,
    width: 66.38,
    height: 90.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 99.72,
    y: 79.47
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.91,
    y: 34.14,
    width: 72.6,
    height: 90.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.20999999999998,
    y: 79.47
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.5,
    y: 34.14,
    width: 82.86,
    height: 90.66,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.93,
    y: 79.47
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.36,
    y: 34.14,
    width: 89.09,
    height: 90.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.09909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 332.90500000000003,
    y: 79.47
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.45,
    y: 34.14,
    width: 94.28,
    height: 90.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424.59,
    y: 79.47
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.73,
    y: 34.14,
    width: 112.69,
    height: 90.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.075,
    y: 79.47
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 584.43,
    y: 34.14,
    width: 115.57,
    height: 90.66,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.073333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 642.2149999999999,
    y: 79.47
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.53,
    y: 124.81,
    width: 142.93,
    height: 82.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.832857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.995,
    y: 166.225
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.53,
    y: 207.64,
    width: 142.93,
    height: 86.89,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6838461538461535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.995,
    y: 251.08499999999998
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.53,
    y: 294.53,
    width: 142.93,
    height: 113.88,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.995,
    y: 351.46999999999997
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.53,
    y: 408.41,
    width: 142.93,
    height: 140.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.074000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.995,
    y: 478.78000000000003
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.53,
    y: 549.15,
    width: 142.93,
    height: 150.85,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.41857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.995,
    y: 624.5749999999999
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.45,
    y: 124.81,
    width: 153.44,
    height: 153.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.16999999999996,
    y: 201.55
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.89,
    y: 124.81,
    width: 155.2,
    height: 153.48,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.952727272727271
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.49,
    y: 201.55
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.09,
    y: 124.81,
    width: 181.91,
    height: 153.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.05333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.0450000000001,
    y: 201.55
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.45,
    y: 278.29,
    width: 207.43,
    height: 205.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.24333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.16499999999996,
    y: 381.02000000000004
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.45,
    y: 483.74,
    width: 207.43,
    height: 216.26,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.047777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.16499999999996,
    y: 591.87
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.88,
    y: 278.29,
    width: 283.12,
    height: 421.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.73818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 558.44,
    y: 489.145
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2020);
export default __webpack_public_path__ + "static/media/2020.d44748601ab387a735225d11b9150f59.svg";
export { ForwardRef as ReactComponent };